import { render } from "./language-settings.vue?vue&type=template&id=558be1ca"
import script from "./language-settings.vue?vue&type=script&lang=js"
export * from "./language-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__